// permissions.js -- Sprint Hub LAY01v1
// usePermissions hook: loads user agent permissions from /api/me
// Module-level cache -- fetches once per page load
// ASCII only. No Unicode. var declarations only.
import { useState, useEffect } from 'react';

var _cache = null;
var _loading = false;
var _listeners = [];

export function clearPermissionsCache() {
  _cache = null;
  _loading = false;
  _listeners = [];
}

export function usePermissions() {
  var _s = useState(_cache);
  var perms = _s[0]; var setPerms = _s[1];

  useEffect(function() {
    if (_cache) { setPerms(_cache); return; }
    if (_loading) {
      _listeners.push(setPerms);
      return;
    }
    _loading = true;
    fetch('/api/me')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (d.ok && d.data && d.data.permissions) {
          _cache = d.data.permissions;
          setPerms(_cache);
          _listeners.forEach(function(fn) { fn(_cache); });
          _listeners = [];
          _loading = false;
        } else {
          // No permissions returned -- use open sentinel
          _cache = {};
          setPerms(_cache);
          _listeners.forEach(function(fn) { fn(_cache); });
          _listeners = [];
          _loading = false;
        }
      })
      .catch(function() {
        _loading = false;
      });
  }, []);

  function _hasPerms() {
    return perms !== null;
  }

  return {
    canView: function(agentId) {
      if (!_hasPerms()) return null; // null = still loading (caller shows spinner)
      if (!agentId) return true;
      var p = perms[agentId];
      if (!p) return false; // no permission row = hidden
      return p.can_view === 1;
    },
    canChat: function(agentId) {
      if (!_hasPerms()) return true;
      if (!agentId) return true;
      var p = perms[agentId];
      return p ? p.can_chat === 1 : false;
    },
    canApprove: function(agentId) {
      if (!_hasPerms()) return true;
      if (!agentId) return true;
      var p = perms[agentId];
      return p ? p.can_approve === 1 : false;
    },
    canSeeFinancials: function(agentId) {
      if (!_hasPerms()) return true;
      if (!agentId) return true;
      var p = perms[agentId];
      return p ? p.can_see_financials === 1 : false;
    },
    canConfigure: function(agentId) {
      if (!_hasPerms()) return true;
      if (!agentId) return true;
      var p = perms[agentId];
      return p ? p.can_configure === 1 : false;
    },
    canExecute: function(agentId) {
      if (!_hasPerms()) return true;
      if (!agentId) return true;
      var p = perms[agentId];
      return p ? p.can_execute === 1 : false;
    },
    loaded: _hasPerms(),
    raw: perms
  };
}
